import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from '@nosto/preact'
import { useState } from 'preact/hooks'

export default ({ facet }) => {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    return (
        <li class={`ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <a
                class="ns-d-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-p-4"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active)
                }}>
                <span class="ns-color-link ns-font-4">{facet.name}</span>
                {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-2 ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )}
                {active ? (
                    // Minus
                    <svg
                        width="16"
                        height="2"
                        viewBox="0 0 16 2"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1 1H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                ) : (
                    // Plus
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8 1V15M1 8H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                )}
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-p-4">
                <div class="ns-d-flex ns-justify-content-between ns-font-4">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2">
                        <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-min`}
                            value={range[0]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1">
                        <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label>
                        <input
                            type="number"
                            class="ns-input-field ns-d-block"
                            id={`ns-${facet.id}-max`}
                            value={range[1]}
                            min={min}
                            max={max}
                            onChange={(e) => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
